<template>
	<div>
		<Toptab/>
		<div class="container details">
			<div class="row">
			  <div class="col-xs-18 col-md-12">
				  <h2>制造业通用erp</h2>
				  <h3>功能说明</h3>
				  <p><b>1.采购业务</b></p>
				  <p>采购订单</p>
				  <p><img src="../assets/img/d-1.png"></p>
				  <p>采购入库</p>
				  <p><img src="../assets/img/d-2.png"></p>
				  <p><b>2.销售业务</b></p>
				  <p>销售合同</p>
				  <p><img src="../assets/img/d-4.png"></p>
				  <p>销售订单</p>
				  <p><img src="../assets/img/d-5.png"></p>
				  <p>销售出库</p>
				  <p><img src="../assets/img/d-3.png"></p>
				  <p>销售退货入库</p>
				  <p><img src="../assets/img/d-6.png"></p>
				  <p><b>3.库存管理</b></p>
				  <p>库间调拨</p>
				  <p><img src="../assets/img/d-7.png"></p>
				  <p>库存盘点</p>
				  <p><img src="../assets/img/d-8.png"></p>
				  <p><b>4.加工业务</b></p>
				  <p>存货拆分</p>
				  <p><img src="../assets/img/d-9.png"></p>
				  <p>成品委托生产订单</p>
				  <p><img src="../assets/img/d-10.png"></p>
				  <p>成品委托生产入库</p>
				  <p><img src="../assets/img/d-11.png"></p>
				  <p><b>6.资金管理</b></p>
			  </div>
			</div>
		</div>
		
		<Footbar/>
	</div>
</template>

<script>
	import Toptab from '../components/toptab.vue'
	import Footbar from "../components/footbar.vue"
	export default {
		components: {
			Toptab,
			Footbar
		},
	  mounted(){
		  
		  
		  
	  }
	}
</script>

<style scoped>
	.header-home{margin: 0;}
	.header{    background-image:none;background-color: #333;min-height: 80px;}
	.details{min-height: 720px;padding: 0 0 4em 0;}
	.details h3{text-align: left;}
	.details h2{text-align: center;margin: 48px 0 24px 0;}
	.details p{line-height: 42px;font-size: 14px; text-align: left;}
	.details p img{max-width: 100%;height: auto;margin: 0 auto;display: table-header-group;}
</style>
